import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { shallowEqual } from '@uswitch/spark.utils';
import { createContext, useContext, useEffect, useState } from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var DropdownContext = /*#__PURE__*/createContext();
export var DropdownContextProvider = function DropdownContextProvider(_ref) {
  var preselectedItem = _ref.selected,
      isMenuOpen = _ref.isMenuOpen,
      onChange = _ref.onChange,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["selected", "isMenuOpen", "onChange", "children"]);

  var _useState = useState(!isMenuOpen),
      _useState2 = _slicedToArray(_useState, 2),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      inInitialState = _useState4[0],
      setInInitialState = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      changeEvent = _useState6[0],
      setChangeEvent = _useState6[1];

  var _useState7 = useState(preselectedItem || {}),
      _useState8 = _slicedToArray(_useState7, 2),
      selected = _useState8[0],
      setSelected = _useState8[1];

  useEffect(function () {
    !inInitialState && onChange && onChange(selected, changeEvent);
  }, [selected, changeEvent, onChange, inInitialState]);

  var handleClick = function handleClick() {
    return setHidden(!hidden);
  };

  var handleKeyUp = function handleKeyUp(e) {
    return (e.key === 'Enter' || e.key === 'Space') && setHidden(!hidden);
  };

  var handleSelect = function handleSelect(value, description, event) {
    if (!shallowEqual({
      value: value,
      description: description
    }, selected)) {
      setSelected({
        value: value,
        description: description
      });
      setChangeEvent(event);
      inInitialState && setInInitialState(false);
    }

    setHidden(true);
  };

  return _jsx(DropdownContext.Provider, {
    value: {
      handleClick: handleClick,
      handleSelect: handleSelect,
      handleKeyUp: handleKeyUp,
      selected: selected,
      hidden: hidden
    },
    children: children
  });
};
export var useDropdownContext = function useDropdownContext() {
  return useContext(DropdownContext);
};